Ext.define('SA.view.quickreport.QuickReportCellMenu', {
    extend: 'Ext.util.Observable',

    constructor(grid) {
        this.callParent();

        this.grid = grid;
    },

    destroy() {
        Ext.destroyMembers(this, 'lastMenu');

        this.grid = null;

        this.callParent();
    },

    getConfig(params) {
        var grid = this.grid,
            {positionEl} = params;

        return {
            xtype: 'arrow-menu',
            alignment: 'right',
            cls: 'sa-quick-report-cell-menu',
            positionEl,
            target: grid,
            track: true,
            width: 270,

            defaults: {
                view: params.view,

                deferHideParentMenus() {
                    Ext.destroy(this.up('arrow-menu'));
                }
            },

            items: [{
                xtype: 'simple-container',
                cls: 'sa-quick-report-cell-menu-header',

                items: [{
                    xtype: 'close-button'
                }]
            }],

            listeners: {
                beforedestroy: () => {
                    params.onHide();

                    this.fireEvent('hide');
                },

                beforerender(menu) {
                    menu.items.each(item => {
                        if (item.beforeMenuShow) {
                            item.beforeMenuShow();
                        }
                    });
                },

                render: () => {
                    params.onShow();

                    this.fireEvent('show', this, positionEl);
                }
            }
        };
    },

    getLocationCaptionHtml(location) {
        return Ext.util.Format.locationRenderer(SA.data.LocationsCache.get(location));
    },

    hide() {
        Ext.destroyMembers(this, 'lastMenu');
    },

    maybeShow(params) {
        var menu = this.lastMenu;

        if (menu && menu.positionEl === params.positionEl && menu.wasRecentlyVisible()) {
            return;
        }

        this.lastMenu = Ext.widget(this.getConfig(params));
    }
});